import { InjectionToken } from '@angular/core';

export const spri_CONFIG = new InjectionToken<unknown>('spri_APP_CONFIG');
